import { render, staticRenderFns } from "./recipe-item.vue?vue&type=template&id=a4e87464&scoped=true"
import script from "./recipe-item.vue?vue&type=script&lang=js"
export * from "./recipe-item.vue?vue&type=script&lang=js"
import style0 from "./recipe-item.vue?vue&type=style&index=0&id=a4e87464&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e87464",
  null
  
)

export default component.exports